import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CompetitorCount, EventItem} from "@model";

@Component({
  selector: 'app-competitor-count',
  templateUrl: './competitor-count.component.html',
  styleUrl: './competitor-count.component.scss'
})
export class CompetitorCountComponent implements OnChanges, OnInit{
   @Input() raceId: number | undefined;
   @Input() event: EventItem | undefined;
   @Input() displayCount: (keyof CompetitorCount)[] = ["total", "paidOrConfirmedCount", "withStartNumber"];
   @Input() size: 'normal' | 'small' = 'normal';
   @Input() hideZeroCounts: boolean = false;

   competitorCount: CompetitorCount | undefined;
   labelsMap = new Map<string, string>();
   classMap = new Map<string, string>();

    ngOnInit(): void {
        this.competitorCount = this.getCompetitorCount();
        this.displayCount.forEach(count => {
            this.labelsMap.set(count, this.getLabel(count));
            this.classMap.set(count, this.getClass(count));
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
      //updating counters
      this.competitorCount = this.getCompetitorCount();
    }

    private getCompetitorCount(): CompetitorCount | undefined {
        if (this.raceId) {
           return this.event?.racesList?.find(r => r.id === this.raceId)?.competitorCount;
        }
        return this.event?.competitorCount;
    }

    private getLabel(count: (keyof  CompetitorCount)): string {
        switch (count) {
            case "didNotFinished":
                return "competitor.status.DNF";
            case "disqualified":
                return "competitor.status.DSQ";
            case "didNotStarted":
                return "competitor.status.DNS";
            case "started":
                return "competitor.status.STA";
            case "finished":
                return "competitor.status.FIN";
            case "paidOrConfirmedCount":
                return "competitors.count.paid";
            case "withStartNumber":
                return "competitor.status.BIB";
            case "total":
                return "competitor.status.REG";
            case "readyForPayment":
                return "competitor.status.RFP";
            default:
                return "";
        }
    }

    private getClass(count: (keyof  CompetitorCount)): string {
        switch (count) {
            case "didNotFinished":
            case "disqualified":
            case "didNotStarted":
                return "black";
            case "started":
            case "paidOrConfirmedCount":
                return "green";
            case "finished":
                return "red";
            case "withStartNumber":
            case "readyForPayment":
                return "yellow";
            case "total":
                return "light-blue";
            default:
                return "";
        }
    }

    trackByCountKey = (index: number, count: keyof CompetitorCount): string => {
        const value = this.competitorCount?.[count] ?? '-';
        return `${count}-${value}`;
    };

}
